module.exports = __webpack_public_path__ + "img/bg_committee_office.b2c34c3c.jpg";